import Styled from './SourceKeys.styled';

export interface SourceKeysProps {
  labels: readonly string[];
  colors: readonly string[];
  title?: string;
}

function SourceKeys({ labels, colors, title }: SourceKeysProps) {
  return (
    <Styled.Wrapper>
      {title ? <Styled.KeyLabel>{title}</Styled.KeyLabel> : null}
      {labels.map((label, index) => (
        <Styled.Item key={`${label}-${index}`}>
          <Styled.ItemDot color={colors[index]} />
          <Styled.ItemLabel>{label}</Styled.ItemLabel>
        </Styled.Item>
      ))}
    </Styled.Wrapper>
  );
}

export default SourceKeys;
